import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router'

@Component({
  selector: 'app-clients',
  templateUrl: './clientDetails.component.html'
})

export class ClientDetailsComponent implements OnInit {
  client: Client;

  constructor(private route:ActivatedRoute) { }

  ngOnInit() {
    var id = this.route.snapshot.params['id'];
    var boundClient = this.clients[this.clients.map(function (item) { return item.key; }).indexOf(id)];


    //boundClient = clients[0];
    //console.log(boundClient);

    if (boundClient == null) {
      boundClient = this.clients[0];
    }
    this.client = boundClient;
  }

  clients: Client[]  = [
    {
      id: 0,
      name: '404 Not Found',
      key: '404',
      logoUrl: '/assets/images/404.jpg',
      websiteUrl: 'https://en.wikipedia.org/wiki/HTTP_404',
      byline: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
        dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
        commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla 
        pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.`,
      summary: `Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem 
        aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim 
        ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione 
        voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, 
        sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima 
        veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis 
        autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem 
        eum fugiat quo voluptas nulla pariatur?`,
      from: '2020-03-20',
      to: '2025-03-20',
      projects: []
    },
    {
    id: 1,
    name: 'The Football Association',
    key: 'the-fa',
    logoUrl: '/assets/images/thefa-logo.png',
    websiteUrl: 'https://www.thefa.com',
    byline:`The Football Association, also known simply as the FA, is the governing body of football in England,
      and the Crown dependencies of Jersey, Guernsey and the Isle of Man. Formed in 1863, it is the oldest football
      association in the world and is responsible for overseeing all aspects of the amateur and professional game
      in its territory. The FA sanctions all competitive football matches within its remit at national level, and
      indirectly at local level through the County Football Associations. - Wikipedia`,
   summary: `We have worked on numerous projects on site at Wembley stadium including high profile revamps of the main fa.com
      portal and the many regional counties' sites, these are built on a Sitecore CMS using MVC. Other notable projects
      involved creating web services to expose data sets internally and externally, implementing payment gateways,
      creating queuing systems for new business processes and migrating whole web farms to new sites.`,
    from: '2011-04-01',
    to: '2020-03-20',
    projects: [
      'Match Officials Administration System',
      'England Supporters Travel Club'
      ]
    },
    {
      id: 2,
      name: 'IoP: Institute of Physics',
      key: 'institute-of-physics',
      logoUrl: '/assets/images/IoP-image.jpg',
      websiteUrl: 'https://www.iop.org',
      byline: `The Institute of Physics (IOP) is a scientific charity devoted to increasing the practice, understanding and
        application of physics. It has a worldwide membership of around 50,000. The IOP supports physics in education, research
        and industry. In addition to this, the IOP provides services to its members including careers advice and professional
        development and grants the professional qualification of Chartered Physicist (CPhys), as well as Chartered Engineer (CEng)
        as a nominated body of the Engineering Council. The IOP's publishing company, IOP Publishing, publishes more than 60
        academic titles. - Wikipedia`,
      summary: `Having assisted during the final stages of a large paid membership project to integrate websites on the various sub
        domains before the live date. We also dealt with issues encountered after deployment and created an admin/reporting system
        to manage the signup process.`,
      from: '2011-01-01',
      to: '2011-04-01',
      projects: []
    },
    {
      id: 3,
      name: 'Chambers and Partners',
      key: 'chambers-and-partners',
      logoUrl: '/assets/images/chambers_logo.png',
      websiteUrl: 'https://chambers.com',
      byline: `The Chambers Guides have been ranking the best law firms and lawyers since 1990, and now cover 185 jurisdictions
        throughout the world. They are not sponsored, endorsed, or associated with, Best Lawyers publications. Chambers rank both
        lawyers and law firms based on the research of 150 full-time editors and researchers employed at their head office in London
        talking to lawyers and clients, conducting in-depth telephone interviews. Many of their researchers are multi-lingual.
        All are trained in the techniques of investigative research.`,
      summary: `As part of a team re-writing the Chambers Student site using an NHibernate data layer and TDD to reflect the contents 
        of the new student book and with the aim of simplifying the annual book launch. The site uses provides business functionality, 
        CMS and WCF services, and we were heavily involved with their team in creating this infrastructure while developing the site.`,
      from: '2010-04-01',
      to: '2011-01-01',
      projects: []
    },
    {
      id: 4,
      name: 'The Childrens Society',
      key: 'childrens-society',
      logoUrl: '/assets/images/childrens-society-logo.gif',
      websiteUrl: 'https://www.childrenssociety.org.uk',
      byline: `The Children's Society, also known as Church of England Children's Society, is an English charity allied to the Church
        of England and driven by a belief that all children deserve a good childhood. - Wikipedia`,
      summary: `Added functionality to an incomplete expenses project. We also managed, tested and delivered it using ASP.NET, TDD, 
        SQL Server 2008 and programming to existing company standards.`,
      from: '2009-11-01',
      to: '2010-04-01',
      projects: []
    },
    {
      id: 5,
      name: 'Tesco',
      key: 'tesco',
      logoUrl: '/assets/images/tesco-logo.png',
      websiteUrl: 'https://www.tesco.com',
      byline: `Tesco PLC is a British multinational grocery and general merchandise retailer headquartered in Welwyn Garden City,
        Hertfordshire, UK. It is the second-largest retailer in the world measured by profits (after Wal-Mart) and third-largest 
        retailer in the world measured by revenues (after Walmart and Carrefour). It has stores in 12 countries across Asia, Europe 
        and North America and is the grocery market leader in the UK (where it has a market share of around 30%), Malaysia, the 
        Republic of Ireland and Thailand. - Wikipedia`,
      summary: `Part of a team creating a distributed order processing system to fulfil customer requests from the Tesco.com 
        website: Creation of web-based internal picking, scheduling and delivery software for a new Tesco.com warehouse, the 
        largest in the south-east Management report creation with complex SQL 2008 stored procedures Updates to existing mobile 
        device software used by delivery staff Working in an agile environment with a team of 10, my main objective was to complete 
        tasks in the development of the order processing system at the heart of the new Tesco site in Aylesford, Kent. Written in C# 
        with an ASP.NET user interface, the development was test driven with NMock 2.0 and WCF services provided the business functionality. 
        Cruise Control, NAnt and MSBuild scripts where used to provide the continuous integration with the Source Safe repository. 
        After the live date much of my work concerned creating management reports and updating mobile device software.`,
      from: '2008-01-01',
      to: '2009-11-01',
      projects: []
    },
    {
      id: 6,
      name: 'Virgin Games',
      key: 'virgin-games',
      logoUrl: '/assets/images/virgingames-logo.png',
      websiteUrl: 'https://www.virgingames.com',
      byline: `Virgin Games is a company that provides online gambling services, predominantly in the United Kingdom, that licences the brand from
        Sir Richard Branson's Virgin Enterprises. The company was established in late 2003 by Virgin Group. In 2013 the company was acquired by 
        Gamesys for an undisclosed sum. Although it is part of the Virgin Group of companies, it is not related to Virgin Interactive, a video-game 
        publisher, that was previously called Virgin Games Ltd. They also run a number of poker tournaments across the United Kingdom. Currently, 
        their games include bingo, poker and a casino with games like roulette and blackjack. - Wikipedia`,
      summary: `A varied assignment concentrating on backend design, lots of data transfer and reporting functionality. We were also responsible 
        for creating an affiliate marketing system and maintenance releases for the existing web-based products concerning poker, casino and bingo.`,
      from: '2005-09-01',
      to: '2007-05-01',
      projects: []
    },
    {
      id: 7,
      name: 'XM London',
      key: 'xm-london',
      logoUrl: '/assets/images/no-logo.png',
      websiteUrl: '',
      byline: `A web design annd hosting company operating out of Paddington, London with a number of web hosting contracts for high profile
        Government agencies and corporations.`,
      summary: `Our consultancy services here provided maintenance and new functionality for three government websites.`,
      from: null,
      to: null,
      projects: []
    },
    {
      id: 8,
      name: 'QCA: The Qualifications and Curriculum Authority',
      key: 'qca',
      logoUrl: '/assets/images/qca-logo.png',
      websiteUrl: 'https://www.qca.org.uk/',
      byline: `The Qualifications and Curriculum Authority (and later QCDA) was a charity, and an executive non-departmental public body of the 
        Department for Education. In England and Northern Ireland, the QCA maintained and developed the National Curriculum and associated assessments, 
        tests and examinations, advising the minister formerly known as the Secretary of State for Children, Schools and Families and later 
        known as the Secretary of State for Education on these matters.`,
      summary: `Our work at the QCA included the following systems:
        Five-day Accreditation - Analysis and prototype design of a large online application used by awarding bodies and government authorities 
        for collaborative development.
        Plan of Provisions – As the sole developer of an additional release of an existing system I was responsible for finalising the design 
        with users, construction of new sections, integrating with the current system, testing and release management.
        OpenQuals - Analysis and design of a web interface to view the summary data gathered and administered from the previously developed applications.
        Standards creation tracking system (Phase 1 & 2) - One of a number of developers who created a qualifications processing system to control the 
        complex data structures associated with qualifications regulated by QCA. Data from the system was viewed and updated by users from UK 
        authorities over secure VPN’s. I was heavily involved with every phase including design, development, testing, UAT and maintenance.`,
      from: null,
      to: null,
      projects: []
    },
    {
      id: 9,
      name: 'Datamonitor',
      key: 'datamonitor',
      logoUrl: '/assets/images/datamonitor-logo.gif',
      websiteUrl: 'http://www.datamonitor.com/',
      byline: `Datamonitor is an international company providing market intelligence, data analysis and opinion via a worldwide network of in-house
        analysts. According to the organization's website in 2011, Datamonitor assists over 6000 of the world’s leading corporations in making 
        strategic and operational decisions. The company uses audited methodologies to deliver their advice across the major industrial sectors. 
        Datamonitor is a division of Informa plc (FTSE: INF), a United Kingdom-based publisher and conference company. - Wikipedia`,
      summary: `Company, sector and industry reporting system - Lead develpment on a system to combine large numbers of unstructured business 
        reports into relational databases. The data was then used to create reporting content that could be personalised and supplied to commercial 
        sites as web content. The project tackled issues such as data warehousing, replication, web content personalisation, user authentication 
        and creating data administration tools.`,
      from: null,
      to: null,
      projects: []
    },
    {
      id: 10,
      name: 'Demon Internet',
      key: 'demon-internet',
      logoUrl: '/assets/images/demon-logo-white.png',
      websiteUrl: 'https://web.archive.org/web/20160526174606/http://demon.net/',
      byline: `Demon Internet was a ground breaking British Internet Service Provider. It was one of the UK's earliest ISPs, especially targeting the "dialup" audience.
        It started life in June 1992 and expanded rapidly to fulfill the exponential demand ofthe dot com boom era.`,
      summary: `In 1998 Demon was bought by Scottish Telecom, a subsidiary of the private utility company Scottish Power. Scottish 
        Telecom rebranded as Thus plc in October 1999 and floated on the London Stock Exchange. Thus plc fully demerged from Scottish Power in 2002. 
        Thus became part of Cable & Wireless plc, and then part of Cable & Wireless Worldwide following a split of its parent. The company was 
        purchased as part of the acquisition of Cable & Wireless Worldwide by Vodafone Group on 27 July 2012. In 2019
        <a href="https://www.theregister.com/2019/01/11/vodafone_to_shutter_demon_internet/" title="Demon closes" class="text-light">Demon closed</a>
        as a brand and customers were transferred to Vodafone.`,
      from: null,
      to: null,
      projects: []
    }
  ];
}

class Client {
  id: number;
  name: string;
  key: string;
  logoUrl: string;
  websiteUrl: string;
  byline: string;
  summary: string;
  from: string;
  to: string;
  projects: string[];
};
